import { useState } from 'react';
import useTeamSettings from '../../../containers/team/hooks/useTeamSettingsService';
import { AttentionItemsModal } from './components/AttentionItemsModal/AttentionItemsModal';
import { getAttentionItems } from './constants/attentionItems';
import { AttentionItem } from './interfaces/attentionItems';
import { dismissItem, isItemDismissed } from './utils/dismissal';

export function GlobalAttentionItemsModal() {
  const { showPubKeyMessageTeam, getTeamSettingsValue } = useTeamSettings();
  const showBqServiceAccountMigration =
    !!getTeamSettingsValue()?.bigquery_service_account_migration_banner_enabled;

  const [items, setItems] = useState<AttentionItem[]>(() =>
    getAttentionItems({ showPubKeyMessageTeam, showBqServiceAccountMigration }).filter(
      item => item.enabled !== false && !isItemDismissed(item.id)
    )
  );
  const [open, setOpen] = useState(() => items.length > 0);

  const removeItem = (id: string) => {
    setItems(prev => {
      const next = prev.filter(item => item.id !== id);
      if (!next.length) setOpen(false);
      return next;
    });
  };

  const handleRemindLater = (id: string) => {
    dismissItem(id);
    removeItem(id);
  };

  const handlePrimaryCta = (item: AttentionItem) => {
    if (item.primaryCta.url) {
      window.open(item.primaryCta.url, '_blank', 'noopener,noreferrer');
    } else {
      item.primaryCta.onClick?.();
    }
    dismissItem(item.id);
    removeItem(item.id);
  };

  return (
    <AttentionItemsModal
      open={open}
      items={items}
      onClose={() => setOpen(false)}
      onRemindLater={handleRemindLater}
      onCta={handlePrimaryCta}
    />
  );
}
